"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/components/auth/Auth";
import { useCookieConsent } from "@/components/cookies/CookieConsentContext";
import { clearIdentity, disableAnalytics, identify, initAnalytics, trackPageView } from "@/services/analytics/mixpanel";
import { classifyPageView } from "@/services/analytics/pageClassification";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";
export default function MixpanelSetup() {
  const $ = _c(22);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    connectedProfile
  } = useAuth();
  const {
    performanceConsent
  } = useCookieConsent();
  const lastTrackedPageKeyRef = useRef(null);
  const identifiedProfileIdRef = useRef(null);
  const hasConsent = performanceConsent === true;
  let t0;
  if ($[0] !== pathname || $[1] !== searchParams) {
    t0 = classifyPageView({
      pathname,
      searchParams
    });
    $[0] = pathname;
    $[1] = searchParams;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const pageView = t0;
  let t1;
  let t2;
  if ($[3] !== hasConsent) {
    t1 = () => {
      if (!hasConsent) {
        disableAnalytics();
        lastTrackedPageKeyRef.current = null;
        identifiedProfileIdRef.current = null;
        return;
      }
      initAnalytics();
    };
    t2 = [hasConsent];
    $[3] = hasConsent;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== connectedProfile || $[7] !== hasConsent) {
    t3 = () => {
      if (!hasConsent) {
        return;
      }
      const profileId = connectedProfile?.id !== undefined && connectedProfile.id !== null ? String(connectedProfile.id) : null;
      if (!profileId) {
        if (identifiedProfileIdRef.current !== null) {
          clearIdentity();
          identifiedProfileIdRef.current = null;
        }
        return;
      }
      if (identifiedProfileIdRef.current === profileId) {
        return;
      }
      identify(profileId);
      identifiedProfileIdRef.current = profileId;
    };
    $[6] = connectedProfile;
    $[7] = hasConsent;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = connectedProfile?.id;
  let t5;
  if ($[9] !== hasConsent || $[10] !== t4) {
    t5 = [t4, hasConsent];
    $[9] = hasConsent;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  useEffect(t3, t5);
  let t6;
  if ($[12] !== connectedProfile || $[13] !== hasConsent || $[14] !== pageView || $[15] !== pathname) {
    t6 = () => {
      if (!hasConsent) {
        return;
      }
      if (lastTrackedPageKeyRef.current === pageView.trackingKey) {
        return;
      }
      lastTrackedPageKeyRef.current = pageView.trackingKey;
      trackPageView(pathname, {
        has_connected_profile: connectedProfile?.id !== undefined && connectedProfile.id !== null,
        logical_page: pageView.logicalPage,
        page_group: pageView.pageGroup,
        route_pattern: pageView.routePattern
      });
    };
    $[12] = connectedProfile;
    $[13] = hasConsent;
    $[14] = pageView;
    $[15] = pathname;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const t7 = connectedProfile?.id;
  let t8;
  if ($[17] !== hasConsent || $[18] !== pageView || $[19] !== pathname || $[20] !== t7) {
    t8 = [t7, hasConsent, pageView, pathname];
    $[17] = hasConsent;
    $[18] = pageView;
    $[19] = pathname;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  useEffect(t6, t8);
  return null;
}